export default __webpack_public_path__ + "images/logoTheBetterSkinCo.cbfa179bc58863bdfcc28c7fa012d822.svg"